import 'aem-libs-react-ts/src/configuration/publicPath'

import { bootstrap } from 'aem-libs-react-ts/src/inlet/bootstrap'

import { App } from './App'
import { APP_NAME } from './constants'
import './i18n'


bootstrap({
  appName: APP_NAME,
  AppComponent: App
})
